import { AddWaitingForRowData } from '@mm/company-ui'
import { defineCapability } from '../capabilities/Capability'

export const ADD_TOPIC = defineCapability<[data: AddWaitingForRowData], Promise<void>>('addTopic')
